import React, { useState, useEffect } from 'react'
import { Panel, Table, Form } from 'rsuite'
import { isEmpty } from 'lodash-es'
import { v4 as uuidv4 } from 'uuid'
import ConfirmWidget from '../confirm/ConfirmWidget'
import EditNumberCell from './cell/EditNumberCell'
import './styles.less'
import classNames from 'classnames'
import { budgetFormat } from '../../utils/formatterUtil'

const { Column, HeaderCell, Cell } = Table

export default function WithdrawalByReviewerEditTable({
  data,
  readOnly,
  register,
  errors,
  control,
  setValue,
  getValues,
  projectBudgetPlan,
  isApprove,
  statusCode,
  disabledForm,
  onChangeTotal = () => {},
}) {
  //const { register, handleSubmit, errors, control, setError, clearErrors } = useForm()
  const [isLoading, setIsLoading] = useState(false)
  const [tableData, setTableData] = useState()
  const [isShowConfirmDelete, setIsShowConfirmDelete] = useState(false)
  const [isEdit, setIsEdit] = useState(false)

  useEffect(() => {
    console.log('data', data)
    if (isEmpty(data)) {
      setTableData()
      return
    }
    if (readOnly || isApprove) {
      setIsEdit(false)
    } else {
      setIsEdit(true)
    }

    const totalData = {
      id: uuidv4(),
      list: 'รวมจำนวนเงินทั้งสิ้น',
      cost: 0,
      isTotal: true,
    }
    setTableData([...data, totalData])
  }, [data, readOnly])

  const handleOnConfirmDelete = () => {
    setIsShowConfirmDelete(false)
  }

  const getTotalSummary = (_tableData) => {
    return _tableData.reduce((pre, cur) => {
      if (cur.cost && !cur.isTotal) {
        return pre + cur.cost
      }
      return pre
    }, 0)
  }

  const getTotalBudget = (_tableData) => {
    return _tableData.reduce((pre, cur) => {
      if (cur.budget && !cur.isTotal) {
        return pre + cur.budget
      }
      return pre
    }, 0)
  }

  const handleOnChangeValue = (value, id) => {
    var _tableData = tableData
    var newData = _tableData.map((item) => {
      if (item.id === id) {
        item.cost = value || 0
      }
      return item
    })
    setTableData(newData)
    var total = getTotalSummary(newData)
    onChangeTotal(total)
  }

  const getMasterBudgetPlanLabel = (masterBudgetPlan) => {
    const planCode = masterBudgetPlan
    let planLabel = ''
    let workPlanLabel = ''
    let actionPlanLabel = ''
    if (planCode) {
      projectBudgetPlan.masterBudgetPlan?.items?.forEach((planItem) => {
        if (planItem.value == planCode.substring(0, 2)) {
          planLabel = planItem.label
          planItem?.children?.forEach((workPlanItem) => {
            if (workPlanItem.value == planCode.substring(0, 6)) {
              workPlanLabel = workPlanItem.label
              workPlanItem?.children?.forEach((actionPlanItem) => {
                if (actionPlanItem.value == planCode) {
                  actionPlanLabel = actionPlanItem.label
                }
              })
            }
          })
        }
      })
      console.log('planCode', planCode)
      return `${planCode} ( ${planLabel} / ${workPlanLabel} / ${actionPlanLabel} )`
    } else {
      return
    }
  }

  return (
    <div className="period-expenses">
      <Panel>
        {tableData && (
          <Form className="form-table">
            <Table
              rowKey="id"
              autoHeight
              data={tableData}
              shouldUpdateScroll={false}
              rowHeight={(rowData) => (rowData?.isDetail ? 210 : 64)}
              wordWrap
            >
              {(statusCode == 2 || statusCode == 3) && (
                <Column width={70} fixed align="center">
                  <HeaderCell>ชุดที่</HeaderCell>
                  <Cell dataKey="numberOfSequence" />
                </Column>
              )}

              <Column width={150} fixed>
                <HeaderCell>รหัสโครงการ</HeaderCell>
                <Cell dataKey="projectCode" />
              </Column>

              <Column flexGrow={1}>
                <HeaderCell>ชื่อโครงการ</HeaderCell>
                <Cell>
                  {(rowData) => {
                    if (rowData.isTotal) {
                      return (
                        <span className={classNames(rowData.isTotal && 'total-summary')}>
                          {rowData.list}
                        </span>
                      )
                    }
                    return <span>{rowData.projectName}</span>
                  }}
                </Cell>
              </Column>

              {/* <Column flexGrow={1}>
                <HeaderCell>แผนงบประมาณ</HeaderCell>
                <Cell>
                  {(rowData) => {
                    if (!rowData.isTotal) {
                      return isEdit ? (
                        <Controller
                          name={`${'budgetPlanCode'}_${rowData.id}`}
                          control={control}
                          defaultValue={
                            rowData['budgetPlanCode'] ||
                            getValues(`${'budgetPlanCode'}_${rowData.id}`)
                          }
                          //rules={rowData.cost && isValidators(projectBudgetPlan?.masterBudgetPlan.validators)}
                          render={(props) => {
                            return (
                              <Cascader
                                className={classNames(
                                  errors[`${'budgetPlanCode'}_${rowData.id}`] && 'is-error'
                                )}
                                size="lg"
                                block
                                menuWidth={220}
                                data={projectBudgetPlan?.masterBudgetPlan.items}
                                value={props.value}
                                onChange={(value) => {
                                  props.onChange(value)
                                  setValue('subBudgetPlan', null)
                                }}
                                placeholder={projectBudgetPlan?.masterBudgetPlan?.label}
                              ></Cascader>
                            )
                          }}
                        />
                      ) : (
                        <span>{getMasterBudgetPlanLabel(rowData.budgetPlanCode)}</span>
                      )
                    }
                    return null
                  }}
                </Cell>
              </Column> */}

              <Column width={150} align="right">
                <HeaderCell>งบประมาณ (บาท)</HeaderCell>
                <Cell>
                  {(rowData) => {
                    if (rowData.isTotal) {
                      return (
                        <span className={'cost-total-summary'}>
                          {`${getTotalBudget(tableData).toLocaleString()}`}
                        </span>
                      )
                    }

                    return budgetFormat(rowData.budget)
                  }}
                </Cell>
              </Column>

              <Column width={200} align="right">
                <HeaderCell style={{ paddingRight: 30 }}>จำนวนเงิน (บาท)</HeaderCell>
                <Cell style={{ paddingRight: 30 }}>
                  {(rowData) => {
                    if (rowData.isTotal) {
                      return (
                        <span className={'cost-total-summary'}>
                          {`${getTotalSummary(tableData).toLocaleString()}`}
                        </span>
                      )
                    } else {
                      return (
                        <EditNumberCell
                          rowData={rowData}
                          dataKey="cost"
                          register={register}
                          control={control}
                          errors={errors}
                          isEdit={isEdit}
                          onChangeValue={handleOnChangeValue}
                          disabled={disabledForm}
                        />
                      )
                    }
                  }}
                </Cell>
              </Column>
            </Table>
          </Form>
        )}
      </Panel>
      <ConfirmWidget
        title={`ยืนยันการลบงวดเงิน`}
        show={isShowConfirmDelete}
        detail={`กรุณายืนยันการลบงวดเงิน`}
        onCancle={() => setIsShowConfirmDelete(false)}
        onConfirm={handleOnConfirmDelete}
      />
    </div>
  )
}
